"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_analytics_1 = require("owa-analytics");
var onListViewTypeOptionSaved_1 = require("owa-options-actions/lib/onListViewTypeOptionSaved");
var saveConversationsOptionStitchName = 'saveConversationsOptionStitchName';
var saveConversationsOption = legacy_1.action('saveConversationsOption')(function saveConversationsOption(newListViewType, conversationSortOrder, hideDeletedItems, userOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var serviceUpdates, sortOrderValue;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    serviceUpdates = [];
                    if (newListViewType !== null && newListViewType !== userOptions.GlobalListViewTypeReact) {
                        userOptions.GlobalListViewTypeReact = newListViewType;
                        onListViewTypeOptionSaved_1.onListViewTypeOptionSaved(newListViewType);
                        serviceUpdates.push({
                            propertyName: 'GlobalListViewTypeReact',
                            propertyType: 'Integer32',
                            propertyValue: "" + newListViewType,
                        });
                    }
                    if (conversationSortOrder) {
                        userOptions.ConversationSortOrderReact = conversationSortOrder;
                        sortOrderValue = void 0;
                        switch (userOptions.ConversationSortOrderReact) {
                            case 'Chronological':
                                sortOrderValue = 0x1;
                                break;
                            case 'Tree':
                                sortOrderValue = 0x2;
                                break;
                            case 'NewestOnTop':
                                sortOrderValue = 0x4;
                                break;
                            case 'NewestOnBottom':
                                sortOrderValue = 0x8;
                                break;
                            case 'ChronologicalNewestOnTop':
                                sortOrderValue = 0x5;
                                break;
                            case 'ChronologicalNewestOnBottom':
                                sortOrderValue = 0x9;
                                break;
                            case 'TreeNewestOnBottom':
                                sortOrderValue = 0xa;
                                break;
                        }
                        serviceUpdates.push({
                            propertyName: 'ConversationSortOrderReact',
                            propertyType: 'Integer32',
                            propertyValue: "" + sortOrderValue,
                        });
                    }
                    if (hideDeletedItems !== null) {
                        userOptions.HideDeletedItems = hideDeletedItems;
                        serviceUpdates.push({
                            propertyName: 'HideDeletedItems',
                            propertyType: 'Boolean',
                            propertyValue: "" + userOptions.HideDeletedItems,
                        });
                    }
                    // Raise stitch so that, if we're running in mail, the conversation cache will be cleaned
                    stitch_1.raiseAction(saveConversationsOptionStitchName)();
                    if (!serviceUpdates.length) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration(serviceUpdates)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
});
exports.saveConversationsOptionFull = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveConversationsOptionFull')(function saveConversationsOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions, optionState = state.optionState;
                    return [4 /*yield*/, saveConversationsOption(optionState.globalListViewType, optionState.conversationSortOrder, optionState.hideDeletedItems, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingConversations';
exports.saveConversationsOptionQuick = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveConversationsOptionQuick')(function saveConversationsOptionQuick(isConversationViewEnabled, newSortOrder, state) {
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [newSortOrder]);
    saveConversationsOption(isConversationViewEnabled ? 0 /* Conversation */ : 1 /* Message */, newSortOrder, null, state.userOptions);
}));
//# sourceMappingURL=saveConversationsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/actions/saveConversationsOption.js
// module id = 3738
// module chunks = 2